/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-29 19:24:06
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-10-29 19:25:11
 * @Content:
 */

import { Dayjs } from "dayjs";
import day from "../utils/day";

export const TIME_FORMATTER = "YYYY-MM-DD HH:mm:ss";
